/* eslint-disable import/no-anonymous-default-export */
import RedFescue from '../../../assets/images/plants/red_fescue.jpeg'
import CreepingButtercup from '../../../assets/images/plants/creeping_buttercup.jpeg'
import CommonVelvetGrass from '../../../assets/images/plants/common_velvetgrass.jpeg'

export default {
  data: [
    {
      id: 137025,
      common_name: "Red fescue",
      slug: "festuca-rubra",
      scientific_name: "Festuca rubra",
      year: 1753,
      bibliography: "Sp. pl. 1:74.  1753",
      author: "L.",
      status: "accepted",
      rank: "species",
      family_common_name: "Grass family",
      genus_id: 1102,
      image: RedFescue,
      synonyms: [
        "Festuca rubra var. arenaria",
        "Bromus secundus",
        "Festuca kitaibeliana",
        "Festuca rubra var. lanuginosa",
        "Festuca michiganica",
        "Festuca pseudovivipara",
        "Festuca fallax",
      ],
      genus: "Festuca",
      family: "Poaceae",
      links: {
        self: "/api/v1/species/festuca-rubra",
        plant: "/api/v1/plants/festuca-rubra",
        genus: "/api/v1/genus/festuca",
      },
    },
    {
      id: 173910,
      common_name: "Creeping buttercup",
      slug: "ranunculus-repens",
      scientific_name: "Ranunculus repens",
      year: 1753,
      bibliography: "Sp. Pl.: 554 (1753)",
      author: "L.",
      status: "accepted",
      rank: "species",
      family_common_name: "Buttercup family",
      genus_id: 1607,
      image: CreepingButtercup,
      synonyms: [
        "Ranunculus repens var. erectus",
        "Ranunculus repens var. pleniflorus",
        "Ranunculus repens var. glabratus",
        "Ranunculus repens var. linearilobus",
        "Ranunculus schlechtendalii",
        "Ranunculus oenanthifolius",
        "Ranunculus lucidus",
        "Ranunculus semidecurrens",
        "Ranunculus repens f. polypetalus",
        "Ranunculus repens f. schlechtendalii",
        "Ranunculastrum reptabundum",
        "Ranunculastrum repens",
        "Ranunculus caleyanus",
        "Ranunculus clintonii",
        "Ranunculus belvisii",
        "Ranunculus prostratus",
        "Ranunculus lagascanus",
        "Ranunculus repens var. degeneratus",
        "Ranunculus repens var. typicus",
        "Ranunculus repens var. villosus",
      ],
      genus: "Ranunculus",
      family: "Ranunculaceae",
      links: {
        self: "/api/v1/species/ranunculus-repens",
        plant: "/api/v1/plants/ranunculus-repens",
        genus: "/api/v1/genus/ranunculus",
      },
    },
    {
      id: 143075,
      common_name: "Common velvetgrass",
      slug: "holcus-lanatus",
      scientific_name: "Holcus lanatus",
      year: 1753,
      bibliography: "Sp. Pl.: 1048 (1753)",
      author: "L.",
      status: "accepted",
      rank: "species",
      family_common_name: "Grass family",
      genus_id: 1064,
      image: CommonVelvetGrass,
      synonyms: [
        "Nothoholcus lanatus",
        "Holcus lanatus subsp. vaginatus",
        "Notholcus lanatus",
        "Ginannia pubescens",
        "Holcus lanatus var. sobolifer",
        "Holcus tuberosus",
        "Holcus aestivalis",
        "Holcus oriolis",
        "Holcus argenteus",
        "Aira holcus-lanata",
        "Holcus lanatus var. vaginatus",
        "Ginannia lanata",
        "Holcus lanatus subsp. tuberosus",
        "Holcus lanatus var. tuberosus",
        "Holcus intermedius",
        "Holcus lanatus f. viviparus",
        "Holcus glaucus",
      ],
      genus: "Holcus",
      family: "Poaceae",
      links: {
        self: "/api/v1/species/holcus-lanatus",
        plant: "/api/v1/plants/holcus-lanatus",
        genus: "/api/v1/genus/holcus",
      },
    }
  ],
  links: {
    self: "/api/v1/plants?zone_id=9",
    first: "/api/v1/plants?page=1\u0026zone_id=9",
    next: "/api/v1/plants?page=2\u0026zone_id=9",
    last: "/api/v1/plants?page=47\u0026zone_id=9",
  },
  meta: { total: 931 },
};
